export const transmissionTableAction = {
  changePage: (state, action) => {
    state.page = action.payload;
  },

  changePageSize: (state, action) => {
    state.pageSize = action.payload;
  },

  changeSearch: (state, action) => {
    state.searchText = action.payload;
  },

  changeSelectedRows: (state, action) => {
    const { reports = [], selectedRows = 0 } = action.payload;

    state.selectedReports = reports;
    state.totalSelectedRows = selectedRows;
  },

  changePhysiciansFilter: (state, action) => {
    state.physiciansFilter = action.payload;
    state.isFilterToggled = true;
  },

  toggleFetchTableData: (state, action) => {
    state.fetchTableData = action.payload;
  },

  setCacheRefresh: (state, action) => {
    state.isCacheRefresh = action.payload;
  },

  yearlyTableFilter: (state, action) => {
    state.year = action.payload;
  },

  changeAntiCoagStatus: (state, action) => {
    state.anticoagStatus = action.payload;
  },

  setSelectedRow: (state, action) => {
    state.selectedRow = action.payload;
  },
};
